import { render, staticRenderFns } from "./TabsContent.vue?vue&type=template&id=4d4ad820&scoped=true&"
import script from "./TabsContent.vue?vue&type=script&lang=js&"
export * from "./TabsContent.vue?vue&type=script&lang=js&"
import style0 from "./TabsContent.vue?vue&type=style&index=0&id=4d4ad820&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d4ad820",
  null
  
)

export default component.exports